import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const UserProfile = lazy(
  () =>
    import('./UserProfile.eager').then(mod => ({
      default: mod.UserProfile,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
